export default {
  data() {
    return {
      appEnv: CURRENT_ENV
    };
  },
  methods: {
    navigateHome() {
      location.href = "/";
    },   
  }
};



// WEBPACK FOOTER //
// ./src/mixins/globalUtilityMixin.js